<template>
  <div id="announcementThree"></div>
</template>

<script>
export default {
  name: "AnnouncementThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        headline: "We just launched something big",
        subheadline:
          "Introducing our new AI-powered feature that will change how you work",
        cta: "Learn More →",
        chip: "Product Update",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("announcementThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const headlineSize = exporting ? 64 : 64 * this.scale;
      const subheadlineSize = exporting ? 28 : 28 * this.scale;
      const ctaSize = exporting ? 24 : 24 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const decorSize = exporting ? 200 : 200 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Decorative NEW badge -->
          <div style="
            position: absolute;
            top: 60px;
            right: -60px;
            font-size: ${decorSize}px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 900;
            color: #000000;
            opacity: 0.04;
            transform: rotate(-15deg);
            pointer-events: none;
            user-select: none;
          ">NEW</div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Announcement content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="
              font-size: ${headlineSize}px;
              font-family: 'Playfair Display', 'Georgia', serif;
              font-weight: 700;
              color: #1a1a1a;
              line-height: 1.15;
              margin-bottom: 24px;
              max-width: 90%;
            ">${this.data.headline}</div>
            
            <div style="
              font-size: ${subheadlineSize}px;
              font-weight: 400;
              color: #666666;
              line-height: 1.5;
              margin-bottom: 32px;
              font-family: 'Inter', 'Helvetica Neue', sans-serif;
            ">${this.data.subheadline}</div>

            ${
              this.data.cta
                ? `
            <p style="
              font-size: ${ctaSize}px;
              font-weight: 700;
              color: #1a1a1a;
              margin: 0 0 32px 0;
              font-family: 'Inter', 'Helvetica Neue', sans-serif;
              display: inline-block;
              position: relative;
            ">
              ${this.data.cta}
              <span style="
                position: absolute;
                bottom: -6px;
                left: 0;
                width: 100%;
                height: 3px;
                background: ${primaryColor};
              "></span>
            </p>
            `
                : ""
            }

            <!-- Chip -->
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
